"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Client_1 = __importDefault(require("./Client"));
class ApiDirectDeposit {
    static getList(token) {
        let url = "/directdeposit/list";
        return Client_1.default.httpGet(url, token);
    }
    static update(token, body) {
        let url = "/directdeposit/update";
        return Client_1.default.httpPost(url, token, body);
    }
    static getBanned(token) {
        let url = "/directdeposit/banned";
        return Client_1.default.httpGet(url, token);
    }
}
exports.default = ApiDirectDeposit;
